
// component
import RouterView from '@/components/router-view.vue';
import trusteeshipRouter from './trusteeship/routing.js';
import financeRoute from './finance/route.js';
import ListComponent from './list/index.vue';
import DetailComponent from './detail/index.vue';
const commonOrderRouter = [
  {
    path: 'list/:type',
    name: 'serviceOrderList',
    component: ListComponent,
    meta: {
      title: '订单列表',
      breadCrumbShowIndexArr: [1, 2]
    }
  },
  {
    path: 'detail',
    name: 'serviceOrderDetail',
    component: DetailComponent,
    meta: {
      title: '订单详情',
      breadCrumbShowIndexArr: [2, 3]
    }
  }
];

export default [
  {
    path: 'trusteeship',
    name: 'trusteeship',
    component: RouterView,
    redirect: '/person-center/orders/trusteeship/list',
    meta: {
      title: '托管订单',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: trusteeshipRouter
  },
  {
    path: 'finance',
    name: 'finance',
    component: RouterView,
    redirect: '/person-center/orders/finance/list',
    meta: {
      title: '金融订单',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: financeRoute
  },
  {
    path: 'farm-machinery',
    name: 'farmMachinery',
    component: RouterView,
    redirect: '/person-center/orders/farm-machinery/list/003',
    meta: {
      title: '农机订单',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: commonOrderRouter

  },
  {
    path: 'plant-protection',
    name: 'plantProtection',
    component: RouterView,
    redirect: '/person-center/orders/plant-protection/list/002',
    meta: {
      title: '飞防订单',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: commonOrderRouter
  }
];
